import CreateCreditDebitNote from '../CreditNotes/CreateCreditNote';

const CreateDebitNote = () => <CreateCreditDebitNote noteType="DEBIT_NOTE" />;

export default CreateDebitNote;
